import { useState } from "react";
import clsx from "clsx";

import { useTranslation } from "lib/i18n/use-translation";
import { Dialog, DialogPanel, DialogTrigger } from "lib/ui/dialog";

import HelpLeftImage from "assets/icons/help-left.svg?react";
import HelpRightImage from "assets/icons/help-right.svg?react";
import HelpIcon from "assets/icons/help.svg?react";
import css from "./help.module.scss";

export function Help() {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Dialog isOpen={isOpen} setIsOpen={setIsOpen} triggerLabel={t("Помощь")}>
      <DialogTrigger className={clsx(css.trigger, isOpen && css.active)}>
        <HelpIcon width={24} height={24} />
      </DialogTrigger>
      {isOpen && (
        <DialogPanel className={css.overlay} onClick={() => setIsOpen(false)}>
          <div
            role="img"
            aria-label={t(
              "Иллюстрация: переворот страницы назад. Клик по левой части страницы или клавиши «Стрелка влево», «Стрелка вверх», PgUp."
            )}
          >
            <HelpLeftImage />
          </div>
          <div
            role="img"
            aria-label={t(
              "Иллюстрация: переворот страницы вперёд. Клик по правой части страницы или клавиши «Стрелка вправо», «Стрелка вниз», PgDown, «Пробел»."
            )}
          >
            <HelpRightImage />
          </div>
        </DialogPanel>
      )}
    </Dialog>
  );
}
